function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { InputField } from '@unite-us/ui';
import { oneOf } from 'prop-types';
import { Field } from 'react-final-form';
import { validateEmail, validatePhone } from './validateUtils';
import { SHARE_METHODS } from '../../constants';
var getProps = function getProps(shareMethod) {
  switch (shareMethod) {
    case SHARE_METHODS.PHONE:
      return {
        name: 'phone',
        label: 'Phone Number',
        validate: validatePhone
      };
    case SHARE_METHODS.EMAIL:
      return {
        name: 'email',
        label: 'Email',
        validate: validateEmail
      };
    default:
      return {
        name: '',
        label: '',
        validate: undefined
      };
  }
};
export default function ShareToField(_ref) {
  var shareMethod = _ref.shareMethod;
  var _getProps = getProps(shareMethod),
    name = _getProps.name,
    label = _getProps.label,
    validate = _getProps.validate;
  return /*#__PURE__*/React.createElement(Field, {
    required: true,
    name: name,
    id: "share-".concat(name, "-field"),
    validate: validate
  }, function (params) {
    return /*#__PURE__*/React.createElement(InputField, _extends({
      label: label,
      required: true
    }, params));
  });
}
ShareToField.propTypes = {
  shareMethod: oneOf([SHARE_METHODS.EMAIL, SHARE_METHODS.PHONE]).isRequired
};
//# sourceMappingURL=ShareToField.js.map